// extracted by mini-css-extract-plugin
export var siteWrapper = "styles-module--site-wrapper--2WuWE";
export var siteContent = "styles-module--site-content--33Okd";